export const SPECS = {
  UseDeliveryOptionsLibInExpress: 'specs.ecom.UseDeliveryOptionsLibInExpress',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ErrorHandlerOnCheckout: 'specs.ecom.ErrorHandlerOnCheckout',
  UseConvertedPricesInExpress: 'specs.ecom.UseConvertedPricesInExpress',
  UseExpressCheckoutSettings: 'specs.ecom.UseExpressCheckoutSettings',
  FixAdditionalFeeWithoutCode: 'specs.ecom.FixAdditionalFeeWithoutCode',
  UseAdditionalFeeTranslatedNameExpress: 'specs.ecom.UseAdditionalFeeTranslatedNameExpress',
  ParallelPromisesInExpressButtonsInit: 'specs.ecom.ParallelPromisesInExpressButtonsInit'
};
//# sourceMappingURL=SPECS.js.map